import { connect } from 'react-redux';
import { I18n } from 'react-i18nify';
import ChipInput from '../../components/advanced_filtering/ChipInput';

import { onChangeUrl, selectIndex } from '../../actions/advanced_filtering';

const mapStateToProps = (state, ownProps) => ({
  name: I18n.t('components.advancedFiltering.urls'),
  inputValue: state.advanced_filtering.ruleModal.urls,
  selectedIndex: state.advanced_filtering.ruleModal.inputIndex,
  error: state.advanced_filtering.selectedRule.error,
});

const mapDispatchToProps = dispatch => ({
  onChange: value => {
    dispatch(onChangeUrl(value));
  },
  onSelectIndex: index => {
    dispatch(selectIndex(index));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChipInput);
